import { Button } from "@/components/ui/button";
import { ArrowUpRight } from "lucide-react";
import { Card } from "./ui/card";
import { Link } from "react-router";
import { Badge } from "./Badge";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { cn } from "@/lib/utils";

export const GetFeaturedCard = ({ className }: { className?: string }) => {
  return (
    <Card className={cn("rounded-xl p-3 border-dashed border-2", className)}>
      <div className="flex flex-col items-start gap-1 h-full">
        <div className="flex gap-2">
          <div className="flex flex-col">
            <h3 className="font-semibold text-base flex gap-1 items-center">Want to be a sponsor?</h3>
          </div>
        </div>
        <div className="flex-1 h-full w-full flex flex-col">
          <p className="text-sm text-gray-700 mb-4 flex-1">Showcase your profile/product here for just $29/month. {" "}
            <Popover>
              [
              <PopoverTrigger className="text-sm underline">
                Learn more
              </PopoverTrigger>
              ]
              <PopoverContent align="start" side="bottom" className="p-3 text-sm">
                This card will feature a direct link to your website/product/social for 30 days. {" "}
                This section will appear on all relevant pages. There will only be 3 featured spots available at a time. {" "}
                <br />
                <br />
                <p>You can view the publicly available <a className="underline" href={import.meta.env.VITE_POSTHOG_LINK}>Web analytics</a></p>
                <br />
                For any queries <a className="underline" href="mailto:bsky.insights@gmail.com">Contact</a>
              </PopoverContent>
            </Popover>
          </p>
          <Link to="https://buymeacoffee.com/sahajjain1z/e/343427" className="group">
            <Button
              variant="secondary"
              className="w-full justify-between"
            >
              Claim your spot now
              <ArrowUpRight className="h-4 w-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
            </Button>
          </Link>
        </div>
      </div>
    </Card>
  );
};
